import TimeTracking from "@/components/timetracking/HoursWorked";

export default [
  {
    path: "/time-tracking/hours-worked",
    name: "HoursWorked",
    component: TimeTracking,
    meta: {
      requiresAuthentication: true
    }
  }
];
